import type { CSSProperties } from 'react'
import { GALLERY_HERO_DEFAULTS, type GalleryWidgetConfig } from './config'

type HeroGridOptions = Pick<GalleryWidgetConfig, 'mainShare' | 'gap' | 'radiusMode' | 'imageBorderRadius'>

/** Percent -> the unitless fraction the stylesheet multiplies by ("0.375" for 37.5%).
 *  Mirrors the toolkit's share_fraction(): three decimals, trailing zeros trimmed. */
export function shareFraction(pct: number): string {
  return (pct / 100).toFixed(3).replace(/0+$/, '').replace(/\.$/, '')
}

/**
 * CSS variables for the desktop hero grid (TwoByFiveGrid). Like the toolkit's
 * Display.php, only values that differ from the defaults are emitted, so an
 * untouched feed keeps byte-identical markup and the stylesheet fallbacks
 * (which equal the pre-#1706 layout) stay in charge. Layout only: no colours.
 */
export function heroGridStyle(o: HeroGridOptions): CSSProperties | undefined {
  const vars: Record<string, string> = {}
  if (o.mainShare !== GALLERY_HERO_DEFAULTS.mainShare) vars['--hrg-main-share'] = shareFraction(o.mainShare)
  if (o.gap !== GALLERY_HERO_DEFAULTS.gap) vars['--hrg-gap'] = `${o.gap}px`
  // The outer-corner radius needs its own variable: the per-tile rule that
  // carries imageBorderRadius is zeroed in this mode.
  if (o.radiusMode !== GALLERY_HERO_DEFAULTS.radiusMode) vars['--hrg-radius'] = `${o.imageBorderRadius}px`
  return Object.keys(vars).length ? (vars as CSSProperties) : undefined
}

/** `data-hr-radius-mode` is stamped only for the non-default mode. */
export function heroGridRadiusMode(o: Pick<GalleryWidgetConfig, 'radiusMode'>): string | undefined {
  return o.radiusMode !== GALLERY_HERO_DEFAULTS.radiusMode ? o.radiusMode : undefined
}
